import { Vertical } from '@weave/schema-gen-ts/dist/shared/vertical/vertical.pb';
import { WeaveLocation } from '@frontend/scope';
import { PracticeVertical } from '../../components/onboarding-flow-components/constants';

export const getDefaultVertical = ({
  locationId,
  locationData,
  stepperVertical,
  userPreferenceVertical,
}: {
  locationId: string;
  locationData: Record<string, WeaveLocation>;
  stepperVertical?: PracticeVertical | string;
  userPreferenceVertical?: PracticeVertical | string;
}): PracticeVertical | undefined => {
  const validPracticeVerticals = Object.values(PracticeVertical);
  // Prefer user preference if valid and not 'Other'
  if (
    userPreferenceVertical &&
    userPreferenceVertical !== PracticeVertical.Other &&
    validPracticeVerticals.includes(userPreferenceVertical as PracticeVertical)
  ) {
    return userPreferenceVertical as PracticeVertical;
  }

  // Prefer stepper vertical if valid
  if (stepperVertical && validPracticeVerticals.includes(stepperVertical as PracticeVertical)) {
    return stepperVertical as PracticeVertical;
  }

  // Fallback to location data
  const vertical = locationData?.[locationId]?.vertical;
  switch (vertical) {
    case Vertical.DENTAL:
      return PracticeVertical.Dental;
    case Vertical.VET:
      return PracticeVertical.Veterinary;
    case Vertical.OPTOMETRY:
      return PracticeVertical.EyeCare;
    default:
      return undefined;
  }
};

export const getDefaultIndustry = ({
  stepperIndustry,
  userPreferenceVertical,
}: {
  stepperIndustry?: string;
  userPreferenceVertical?: PracticeVertical | string;
}) => {
  // Return industry name if userPreferenceVertical is not a valid PracticeVertical (other value saved)
  if (userPreferenceVertical && !Object.values(PracticeVertical).includes(userPreferenceVertical as PracticeVertical)) {
    return userPreferenceVertical;
  }

  if (stepperIndustry) {
    return stepperIndustry;
  }

  return '';
};
